<div class="subtask-create" [formGroup]="form">
  <div class="mb-2">
    <div class="new-select-label">{{ 'Tasks.newTask' | translate }}</div>
    <input-v2
      #taskTitle
      [errMessages]="errorMessages"
      [class]="'required'"
      [formControlName]="TASK_SIDENAV_FORM.description"
      [placeholder]="'ProjectContacts.List.name' | translate"
    ></input-v2>
  </div>
  <div class="row">
    <div class="col-12 mb-2">
      <employee-search
        #employeeSearch
        [form]="form"
        [projectId]="taskService.formProjectId"
        [controlName]="TASK_SIDENAV_FORM.assignedTo"
      />
    </div>
    <div class="col-12 mb-2">
      <div class="new-select-label">{{ 'realizationTerm' | translate }}</div>
      <daterangepicker-v2
        #datepicker
        (rangeChanged)="rangeChanged($event)"
        [title]="'Projects.selectDeadline' | translate"
      />
    </div>
  </div>
  <div class="mt-2 d-flex flex-column flex-sm-row justify-content-between w-100 align-items-center relative">
    <app-action-button-link-like
      class="mb-3 mb-sm-0"
      [hidden]="form.dirty"
      [text]="'cancel' | translate"
      (onClick)="discardAdding()"
    />

    <app-action-button-link-like
      class="mb-3 mb-sm-0"
      [hidden]="!form.dirty"
      (onClick)="discardAdding()"
      [text]="'cancel' | translate"
    />

    <app-button
      class="px-3"
      (onClick)="saveSubtask()"
      [disabled]="loading"
      [loading]="loading"
      [config]="{
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        size: ButtonSize.SMALL,
        text: 'Tasks.saveSubtask' | translate
      }"
    />
  </div>
</div>
